export class Config {

    // 本地环境
    // static apiServer = "http://192.168.1.176:9981/";
    // static sysUrl = "/";

    //线网
    // static apiServer = "http://193.112.38.50:9973/";

    // Azure UAT
    // static apiServer = "https://wiluat.thei.edu.hk/api/";
    // static imgServer = 'https://vtctheiwilstorage.blob.core.windows.net/wil/'; // local、ais env、UAT 使用
    // static sysUrl = "/wil_student_pc/";

    // Azure Prod
    static apiServer = "https://wil.thei.edu.hk/api/";
    static imgServer = 'https://vtctheiwilprodstorage.blob.core.windows.net/wil/';
    static sysUrl = "/student/";

    static apiBackServer = Config.apiServer + "student/back/";
    static apiDownloadServer = Config.apiServer + "student/download/";
    static uploadTestServer = Config.apiServer + "file/imageUpload";//上传测试地址
    static assignmentUploadServer = Config.apiServer + "file/assignmentUpload";//上传测试地址

    static tokenPrefix = 'wilStudent';

    // ADFS UAT
    // static logoutUri = 'https://fs.uat.vtc.edu.hk/adfs/oauth2/logout';
    // static authorizeUri = 'https://fs.uat.vtc.edu.hk/adfs/oauth2/authorize';
    // static clientId = 'a6bcc4b4-9507-4f2d-98c5-79355e635ea1';
    // static scope = 'openid';
    // static redirectUri = 'https://wiluat.thei.edu.hk/wil_student_pc/';

    // ADFS Prod
    static logoutUri = 'https://fs.vtc.edu.hk/adfs/oauth2/logout';
    static authorizeUri = 'https://fs.vtc.edu.hk/adfs/oauth2/authorize';
    static clientId = '44816fa3-faf8-4c74-8461-8ce1be3d9ac5';
    static scope = 'openid';
    static redirectUri = 'https://wil.thei.edu.hk/student/';

    static funcImg = Config.imgServer + "sysFunc/original/"; //模块图片路径图
    static pictureScrollImg = Config.imgServer + "pictureScroll/original/";//图片管理模块原图路径
    static funcImg = Config.imgServer + "sysFunc/original/"; //模块图片路径图
    static partnerImg = Config.imgServer + "partner/original/"; //company logo图片路径图
    static studentPhotoImg = Config.imgServer + "studentPhoto/original/"; //student photo原图路径
    static studentPhotoPath = Config.imgServer + "studentPhoto/thumbnail/"; //student photo缩略图路径
    static academicPhotoImg = Config.imgServer + "academicPhoto/original/"; //academic photo原图路径
    static studentFiles = Config.imgServer + "student/"; //student附件
    static resourceFiles = Config.imgServer + "resource/"; //resource附件
    static jobApplFiles = Config.imgServer + "jobAppl/"; //申请工作附件
    static keyDocument = Config.imgServer + "keyDocument/"; //key Document附件
    static wpaApplImg = Config.imgServer + "wpaAppl/original/"; //wpa 图片
    static assign = Config.imgServer + "assign/"; // Assignment 附件

    static header = {
        'authorization': "",
        'Content-Type': 'application/json;charset=UTF-8'
    };

    static headers = {
        'Content-Type': 'application/json;charset=UTF-8'
    };

    //PC登录人信息
    static userInfo = {
        token: "",
        userId: "",
        userName: "",

        defaultUserRoleId: "",
        defaultRoleId: "",
        roleCode: "",
        roleName: "",
    };

    static academicInfo = {};
    static partnerInfo = {};
    static studentInfo = {};
    static programmeInfo = {};
    static cohortYear = "";
    static cohort = {};
    static sasToken = '';

    //模块权限信息--控制按钮显示
    static funcInfo = {
        canSelect: 'N',
        canInsert: 'N',
        canUpdate: 'N',
        canDelete: 'N',
        canAudit: 'N',
        canView: 'N',
        canUpload: 'N',
        canDownload: 'N',
    };

    static noOperationList = [];

    static openKeys = [];//默认展开的menu的Key集合

    // 訪問設備信息
    static equipmentInfo = {
        type: 'pc', //默认是pc(设备类型phone/iPad/pc)
        name: null,
        isWx: null,
    };

    static dateFormat = 'YYYY-MM-DD'; //日期格式化样式
    static dateFormatItem2 = 'YYYY-MM-DD HH:mm'; //日期格式化样式时分秒
    static dateFormatALL = 'YYYY-MM-DD HH:mm:ss'; //日期格式化样式
    static dateFormat3 = '_YYYYMMDDHHmmssSSS'; //日期格式化样式
    static dateFormat4 = '_YYYYMMDD'; //日期格式化样式
    static dateFormat5 = 'YYYY/MM/DD'; //日期格式化样式
    static dateFormat6 = 'YYYY/MM'; //日期格式化样式
    static dateFormat7 = 'YYYY'; //日期格式化样式
    static dateFormat8 = 'YYYYMM'; //日期格式化样式
    static dateFormat9 = 'YY'; //日期格式化样式
    static allCnDate = 'YYYY年MM月DD日 HH:mm:ss';
    static dateFormatEn = "DD MMM YYYY";

    static ckEditorConfig = {
        toolbar: {
            items: [
                'sourceEditing',
                '|', 'undo', 'redo',
                '|', 'heading',
                '|', 'findandReplace', 'alignment', 'bold', 'italic', 'underline', 'code',
                'horizontalLine', 'removeformat', 'link', 'strikethrough', 'subscript', 'superscript', 'blockQuote', 'specialCharacters',
                '|', 'FontSize', 'FontColor', 'FontBackgroundColor', 'FontFamily', 'highlight',
                '|', 'numberedList', 'bulletedList', 'todoList', 'outdent', 'indent', 'pageBreak',
                '|', 'insertImage'//,'cKFinder'
                , 'insertTable', 'mediaEmbed',
            ]
        },
        //设置字体
        fontFamily: {
            options: [
                'default',
                'Blackoak Std',
                '宋体,SimSun',
                '新宋体,NSimSun',
                '微软雅黑,Microsoft YaHei',
                '楷体_GB2312,KaiTi_GB2312',
                '隶书,LiSu',
                '幼园,YouYuan',
                '华文细黑,STXihei',
            ]
        },
        image: {
            styles: [
                'full', 'alignLeft', 'alignCenter', 'alignRight'
            ],
            resizeOptions: [
                {
                    name: 'resizeImage:原尺寸',
                    label: '原尺寸',
                    value: null
                },
                {
                    name: 'resizeImage:25',
                    label: '25%',
                    value: '25'
                },
                {
                    name: 'resizeImage:50',
                    label: '50%',
                    value: '50'
                },
                {
                    name: 'resizeImage:75',
                    label: '75%',
                    value: '75'
                }
            ],
            toolbar: [
                // 'imageStyle:full',
                // 'imageStyle:side',
                'imageStyle:alignLeft',
                'imageStyle:alignCenter',
                'imageStyle:alignRight',
                '|',
                'resizeImage',
                '|',
                'toggleImageCaption',
                'imageTextAlternative',
                'linkImage'
            ],
        },
        table: {
            contentToolbar: [
                'tableColumn',
                'tableRow',
                'mergeTableCells',
                'tableCellProperties',
                'tableProperties'
            ]
        },
        simpleUpload: {
            uploadUrl: Config.apiServer + "ckEditorUploadImg/uploadImg",
            headers: {
                Authorization: Config.header.authorization
            }
        },
    };

    static ckEditorConfigWebsite = {
        toolbar: {
            items: [
                'sourceEditing',
                '|', 'undo', 'redo',
                '|', 'heading',
                '|', 'findandReplace', 'alignment', 'bold', 'italic', 'underline', 'code',
                'link', 'horizontalLine', 'removeformat', 'strikethrough', 'blockQuote', 'specialCharacters',
                '|', 'FontSize', 'FontColor', 'FontBackgroundColor', 'FontFamily', 'highlight',
                '|', 'numberedList', 'bulletedList', 'todoList'
            ]
        },
        //设置字体
        fontFamily: {
            options: [
                'default',
                'Blackoak Std',
                '宋体,SimSun',
                '新宋体,NSimSun',
                '微软雅黑,Microsoft YaHei',
                '楷体_GB2312,KaiTi_GB2312',
                '隶书,LiSu',
                '幼园,YouYuan',
                '华文细黑,STXihei',
            ]
        },
    };

    static backLang = "EN";

    static cohortProgList = [];

    static currentUrl = "";
}